import { render, staticRenderFns } from "./FieldRadioButtons.vue?vue&type=template&id=0ba510ae&scoped=true"
import script from "./FieldRadioButtons.vue?vue&type=script&lang=ts"
export * from "./FieldRadioButtons.vue?vue&type=script&lang=ts"
import style0 from "./FieldRadioButtons.vue?vue&type=style&index=0&id=0ba510ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba510ae",
  null
  
)

export default component.exports